import { Breakpoints } from "utilities/enumerations/breakpoints";
import useBreakpoint, {
    BreakpointComparer,
} from "utilities/hooks/use-breakpoint";

const useNotebookBreakpoints = () => {
    const isMobile = useBreakpoint(
        Breakpoints.SmallTablet,
        BreakpointComparer.MaxWidth
    );
    const isLaptop = useBreakpoint(
        Breakpoints.Laptop,
        BreakpointComparer.MaxWidth
    );

    return { isMobile, isLaptop };
};

export default useNotebookBreakpoints;
